export const VN_PAGE_KEY = 'vnPage';
export const VN_PRODUCTS_KEY = 'vnProducts';
export const HA_APP_KEY = 'haApp';
export const VN_NATIVE_APP_KEY = 'vnNativeApp';
/**
 * Alias for diffs emitted by {@link ClientConfigService#updates}.
 *
 * @stable
 */
export type ClientConfigDiff = Map<string, Map<string, any>>;
``;
/**
 * Options for {@link ClientConfigService#update}.
 *
 * @stable
 */
export interface UpdateOptions {
    /**
     * If false, deletes existing config properties if not specified in the update object. Default is `true`.
     */
    keepExistingProperties: boolean;
}
